module.exports = __webpack_public_path__ + "media/images/logos/vertical-white-ba179c5dfa093147e2a911bd0708bfe1.svg";